import { ServiceCategory } from '@prisma/client';
import axios from 'axios';

export async function createServiceCategory(
  data: Omit<ServiceCategory, 'id' | 'headline' | 'description'>
) {
  const response = await axios.post('/api/service-category', data);
  return response.data;
}

export async function updateServiceCategory(
  id: string,
  data: Partial<ServiceCategory>
) {
  const response = await axios.patch(`/api/service-category/${id}`, data);
  return response.data;
}

export async function deleteServiceCategory(id: string) {
  const response = await axios.delete(`/api/service-category/${id}`);
  return response.data;
}
